document.addEventListener('DOMContentLoaded',()=>{
    const toggle=document.querySelector('[data-menu-toggle]');
      const nav=document.querySelector('[data-main-nav]');
        if(toggle&&nav){
            const close=()=>{nav.classList.remove('is-open');toggle.setAttribute('aria-expanded','false')};
                toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open)});
                    nav.querySelectorAll('a').forEach(link=>link.addEventListener('click',close));
                        document.addEventListener('keydown',event=>{if(event.key==='Escape'&&nav.classList.contains('is-open')){close();toggle.focus()}});
                          }
                            document.querySelectorAll('[data-faq-button]').forEach(button=>button.addEventListener('click',()=>{const item=button.closest('.faq-item');const open=item.classList.toggle('is-open');button.setAttribute('aria-expanded',String(open))}));
                            });

